/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import utils, { TJoin, TModule, TNonEmptyArray, TRole, TRoleClaim, TTenant, TUserRole } from "../../helpers/utils.graphql";
import { CommandResult_Role, CommandResult_Void } from "../../helpers/types.graphql";
import { CommandResult } from "../fragment.graphql";

export type TGlobal = TRole
  | TJoin<"tenant", TTenant>
  | TJoin<"module", TModule>
  | TJoin<"userRoles", TUserRole>
  | TJoin<"roleClaims", TRoleClaim>

type TRoleCreateFunctions = { create: CommandResult_Role };
export type TRoleCreateMutations = { role: TRoleCreateFunctions };
export const roleCreate = (fields: TNonEmptyArray<TGlobal>) => gql`
  mutation roleCreate($role: RoleCreateInputType!) {
    role {
      create(role: $role) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_Role")}
`;

type TRoleUpdateFunctions = { update: CommandResult_Role };
export type TRoleUpdateMutations = { role: TRoleUpdateFunctions };
export const roleUpdate = (fields: TNonEmptyArray<TGlobal>) => gql`
  mutation roleUpdate($roleUpdateInput: RoleUpdateInputType!) {
    role {
      update(roleUpdateInput: $roleUpdateInput) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_Role")}
`;

type TRoleDeleteFunctions = { delete: CommandResult_Void };
export type TRoleDeleteMutations = { role: TRoleDeleteFunctions };
export const roleDelete = () => gql`
  mutation roleDelete($id: Guid!, $permanent: Boolean) {
    role {
      delete(id: $id, permanent: $permanent) {
        ...COMMAND_RESULT
      }
    }
  }
  ${CommandResult("CommandResult_Void")}
`;